'use strict';

jQuery.fn.style = function() {
	let _ = $(this);
	let raw = _.attr('style');
	let obj = {};

	if (raw === undefined || raw === '')
		return obj;

	let groups = raw.split(';');
	for (var i in groups) {
		let group = groups[i];

		if (group == '') continue;

		group = group.split(':');
		obj[group[0].trim()] = group.slice(1).join('').trim();
	}

	return obj;
}

jQuery.fn.removeStyle = function(_key) {
	let _ = $(this);
	let _st_ = _.style();

	if (! _st_)
		return this;

	delete _st_[_key];

	if (! Object.keys(_st_).length) {
		_.removeAttr('style');
		return this;
	}

	let str = '';
	for (let key in _st_)
		str += key + ': ' + _st_[key] + '; ';
	str = str.slice(0,-1);

	_.attr('style', str);

	return this;
}

jQuery.fn.addStyle = function (_obj) {
	if (! _obj) return this;

	let _ = $(this);

	if (typeof _obj === 'array' && _obj.length === 0)
		return this;

	switch (typeof _obj) {
		case 'string':
			if (_obj === '') return this;

			if (_obj.indexOf(':') === -1)
				throw new Error('$.addStyle("' + _obj + '") - нехватает значания стиля.')

			let newObj = {}
			let split = _obj.split(';')
			for (var i in split) {
				if (split[i] === '') continue;

				let group = split[i].split(':');
				newObj[group[0].trim()] = group[1].trim();
			}

			return _.addStyle(newObj);

			break;

		case 'object':
			if (Object.keys(_obj).length === 0) return this;

			let _st_ = _.style();

			for (let key in _obj)
				_st_[key] = _obj[key];

			let str = '';
			for (let key in _obj)
				str += key + ': ' + _obj[key] + '; ';
			str = str.slice(0,-1);

			_.attr('style', str);
			
			return this;

			break;

		default:
			return this;
	}
}